import { useTranslation } from 'src/hooks';
import { Typography } from 'src/components/atoms';
import { FlexColumn } from 'src/components/layout';

interface Props {
  filesNotFound: boolean;
  isSearchResultNotFound: boolean;
}

export const MediaFilesNotFound = ({ filesNotFound, isSearchResultNotFound }: Props) => {
  const { t } = useTranslation();

  if (!filesNotFound && !isSearchResultNotFound) {
    return null;
  }

  return (
    <FlexColumn textAlign='center' alignItems='center'>
      <Typography>
        {isSearchResultNotFound
          ? t('pages.mymes.editor.blobs.library.media_search_empty')
          : t('pages.mymes.editor.blobs.library.media_empty')}
      </Typography>
    </FlexColumn>
  );
};
